import React, { useEffect, useState } from "react";
import { LoadScript } from "@react-google-maps/api";

// Loads the Google Maps script once and reports "ready" or "error" through
// onStatusChange. It renders nothing itself, so the page's inputs stay usable
// while the script loads or if it fails.
//
// Why LoadScript and not the useJsApiLoader hook: GarageForm uses LoadScript,
// which deletes window.google when it unmounts. The hook caches "already loaded"
// and would then render a broken map, while LoadScript simply loads it again.

const isGoogleMapsAlreadyLoaded = () => Boolean(window.google?.maps?.Map);

const GoogleMapsScript = ({ onStatusChange }) => {
  // LoadScript refuses to run (and never calls onLoad) when another loader on the
  // page already added Google Maps, so in that case we are simply ready.
  const [shouldInjectScript] = useState(() => !isGoogleMapsAlreadyLoaded());

  useEffect(() => {
    if (!shouldInjectScript) onStatusChange("ready");
  }, [shouldInjectScript, onStatusChange]);

  if (!shouldInjectScript) return null;

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_API}
      loadingElement={<></>}
      onLoad={() => onStatusChange("ready")}
      onError={() => onStatusChange("error")}
    />
  );
};

export default GoogleMapsScript;
